import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

interface CustomFieldsDisplayProps {
  fields: any[];
}

export function CustomFieldsDisplay({ fields }: CustomFieldsDisplayProps) {
  if (!fields || fields.length === 0) return null;

  const formatValue = (field: any) => {
    if (!field.field_value) return 'N/A';

    switch (field.field_type) {
      case 'date':
        try {
          return format(new Date(field.field_value), 'MMM d, yyyy');
        } catch {
          return field.field_value;
        }
      
      case 'currency':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(field.field_value);
      
      case 'percentage':
        return `${field.field_value}%`;
      
      default:
        return field.field_value;
    }
  };

  return (
    <div>
      <h3 className="font-medium mb-3">Additional Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {fields.map((field) => (
          <Card key={field.id} className="p-3">
            <div className="text-xs text-muted-foreground mb-1">{field.field_label}</div>
            <div className="font-medium">{formatValue(field)}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
